import React from 'react';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './DownloadGroup.styles';
import { NoResultsView } from '@shared/components/NoResultsView';
import { ThemeProps } from '@styles/theme';
import { DownloadGroupProps } from 'Download/download.types';

import { DownloadCard } from '../DownloadCard';

export * from 'Download/download.types';

export const DownloadGroup: React.FC<DownloadGroupProps> = ({ name, description, downloadables }) => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    return (
        <div className={styles.groupWrapper}>
            <div className={styles.groupHeader}>
                <div className={styles.h4}>{name}</div>
                {description && <div className={styles.descriptionText}>{description}</div>}
            </div>

            {downloadables && downloadables.length > 0
                ? (
                    <div className={styles.cardList}>
                        {downloadables.map((d, i) => (
                            <DownloadCard key={d.idLast ?? `${name}-${i}`} downloadable={d} groupName={name} />
                        ))}
                    </div>
                )
                : <NoResultsView entityName='resources' />}
        </div>
    );
};
